var escape = require("../../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.logo {\n    width: 380px;\n    height: 226px;\n    background-image: url(" + escape(require("../../images/logo.png")) + ");\n}\n", ""]);

// exports
